import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { responsive } from '@hivebrite/design-system/Theme';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { mapImage } from 'helpers/mapImage';

const backgroundImage = ({ zoom, height, width, lat, lng, offsetX, offsetY }) =>
  lat
    ? `url('${mapImage({
        zoom,
        height,
        width,
        lat,
        lng,
        offsetX,
        offsetY,
      })}')`
    : 'inherit';

const Image = styled(Box)`
  flex: 1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${responsive('m')`
    border-radius: ${(props) => `${props.theme.input.borderRadius}px`};
  `}
`;

const EmptyWrapper = styled(Box)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const MapPreview = ({
  zoom,
  height,
  width,
  lat,
  lng,
  offsetX,
  offsetY,
  className,
}) => (
  <Wrapper height={height} width={width} lat={lat} className={className}>
    <Image
      style={{
        backgroundImage: backgroundImage({
          zoom,
          height,
          lat,
          lng,
          offsetX,
          offsetY,
        }),
      }}
    >
      {!lat && (
        <EmptyWrapper>
          <Box mb={4} color="primary">
            <FontAwesomeIcon
              color="primary"
              height="48px"
              iconName="map-location-dot"
              iconType="duotone"
            />
          </Box>
          <Box
            font="metadata-regular-dove"
            css={css`
              max-width: 165px;
              text-align: center;
            `}
          >
            {__('Share your location to preview it on the map')}
          </Box>
        </EmptyWrapper>
      )}
    </Image>
  </Wrapper>
);

export default MapPreview;

const Wrapper = styled(Box).attrs(() => ({
  mt: 6,
}))`
  border: ${(props) =>
    props.lat ? 'inherit' : `1px solid ${props.theme.input.borderColor}`};
  border-radius: ${(props) => `${props.theme.input.borderRadius}px`};
`;
